"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _TimelineStateContext = _interopRequireDefault(require("../timeline/TimelineStateContext"));

var _Columns = _interopRequireDefault(require("../columns/Columns"));

var _generic = require("../utility/generic");

var _GroupRow = _interopRequireDefault(require("../row/GroupRow"));

var _Items = _interopRequireDefault(require("../items/Items"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Rows =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Rows, _React$Component);

  function Rows() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Rows);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Rows)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "initState", {
      dragging: false,
      resizing: false,
      dragOffset: 0,
      interactingItemId: undefined
    });

    _defineProperty(_assertThisInitialized(_this), "state", _this.initState);

    _defineProperty(_assertThisInitialized(_this), "handleDragStart", function (dragging, dragOffset, itemId) {
      _this.setState({
        dragging: dragging,
        dragOffset: dragOffset,
        interactingItemId: itemId
      });
    });

    _defineProperty(_assertThisInitialized(_this), "clearState", function () {
      _this.setState(_this.initState);
    });

    _defineProperty(_assertThisInitialized(_this), "handleResizeEnd", function (itemId, resizeTime, resizeEdge, timeDelta) {
      _this.props.itemResized(itemId, resizeTime, resizeEdge, timeDelta);

      _this.clearState();
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragEnd", function () {
      _this.clearState();
    });

    _defineProperty(_assertThisInitialized(_this), "handleResizeStart", function (resizing, itemId) {
      _this.setState({
        resizing: resizing,
        interactingItemId: itemId
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getGroupByItemId", function (itemId) {
      var _this$props = _this.props,
          items = _this$props.items,
          keys = _this$props.keys;
      var item = items.find(function (i) {
        return (0, _generic._get)(i, keys.itemIdKey) === itemId;
      });
      var groupId = (0, _generic._get)(item, keys.itemGroupKey);
      return groupId;
    });

    _defineProperty(_assertThisInitialized(_this), "getItemDimensionsHelper", function (itemId) {
      var groupsWithItemsDimensions = _this.props.groupsWithItemsDimensions;

      var groupId = _this.getGroupByItemId(itemId);

      var group = groupsWithItemsDimensions[groupId];
      var itemDimensions = group.itemDimensions.find(function (i) {
        return i.id === itemId;
      });
      if (itemDimensions) return itemDimensions.dimensions;else return undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "getItemAbsoluteLocation", function (itemId) {
      var groupsWithItemsDimensions = _this.props.groupsWithItemsDimensions;
      var groupHeights = _this.props.groupHeights;

      var groupId = _this.getGroupByItemId(itemId);

      var group = groupsWithItemsDimensions[groupId];
      var itemDimensions = group.itemDimensions.find(function (i) {
        return i.id === itemId;
      });
      if (!itemDimensions) return;
      var groupIndex = group.index;
      var groupTop = groupHeights.reduce(function (acc, height, index) {
        if (index < groupIndex) return acc + height;else return acc;
      }, 0);
      return {
        left: itemDimensions.dimensions.left,
        top: groupTop + itemDimensions.dimensions.top
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getLayerRootProps", function () {
      return {
        style: {// height: '100%'
        }
      };
    });

    return _this;
  }

  _createClass(Rows, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          groupHeights = _this$props2.groupHeights,
          groups = _this$props2.groups,
          itemRenderer = _this$props2.itemRenderer,
          lineHeight = _this$props2.lineHeight,
          itemHeightRatio = _this$props2.itemHeightRatio,
          stackItems = _this$props2.stackItems,
          canChangeGroup = _this$props2.canChangeGroup,
          canMove = _this$props2.canMove,
          canResize = _this$props2.canResize,
          canSelect = _this$props2.canSelect,
          useResizeHandle = _this$props2.useResizeHandle,
          groupTops = _this$props2.groupTops,
          dragSnap = _this$props2.dragSnap,
          minResizeWidth = _this$props2.minResizeWidth,
          itemResizing = _this$props2.itemResizing,
          moveResizeValidator = _this$props2.moveResizeValidator,
          itemDrag = _this$props2.itemDrag,
          itemDrop = _this$props2.itemDrop,
          onItemDoubleClick = _this$props2.onItemDoubleClick,
          onItemContextMenu = _this$props2.onItemContextMenu,
          itemSelect = _this$props2.itemSelect,
          scrollRef = _this$props2.scrollRef,
          itemResized = _this$props2.itemResized,
          selected = _this$props2.selected,
          selectedItem = _this$props2.selectedItem,
          verticalLineClassNamesForTime = _this$props2.verticalLineClassNamesForTime,
          timeSteps = _this$props2.timeSteps,
          minUnit = _this$props2.minUnit,
          Layers = _this$props2.rowRenderer,
          rowData = _this$props2.rowData,
          groupsWithItemsDimensions = _this$props2.groupsWithItemsDimensions,
          clickTolerance = _this$props2.clickTolerance,
          onRowClick = _this$props2.onRowClick,
          onRowDoubleClick = _this$props2.onRowDoubleClick,
          horizontalLineClassNamesForGroup = _this$props2.horizontalLineClassNamesForGroup,
          onRowContextClick = _this$props2.onRowContextClick,
          items = _this$props2.items,
          keys = _this$props2.keys;
      var _this$context = this.context,
          getTimelineState = _this$context.getTimelineState,
          getLeftOffsetFromDate = _this$context.getLeftOffsetFromDate,
          getDateFromLeftOffsetPosition = _this$context.getDateFromLeftOffsetPosition;

      var _getTimelineState = getTimelineState(),
          visibleTimeStart = _getTimelineState.visibleTimeStart,
          visibleTimeEnd = _getTimelineState.visibleTimeEnd,
          canvasTimeStart = _getTimelineState.canvasTimeStart,
          canvasTimeEnd = _getTimelineState.canvasTimeEnd,
          canvasWidth = _getTimelineState.canvasWidth,
          timelineUnit = _getTimelineState.timelineUnit,
          timelineWidth = _getTimelineState.timelineWidth,
          resizeEdge = _getTimelineState.resizeEdge,
          resizeTime = _getTimelineState.resizeTime;

      return _react["default"].createElement("div", {
        style: {
          position: 'absolute',
          top: 0
        }
      }, groupHeights.map(function (groupHeight, i) {
        var groupId = (0, _generic._get)(groups[i], keys.groupIdKey);
        var group = groupsWithItemsDimensions[groupId];
        return _react["default"].createElement(_GroupRow["default"], {
          clickTolerance: clickTolerance,
          onContextMenu: function onContextMenu(evt) {
            return onRowContextClick(evt, i);
          },
          onClick: function onClick(evt) {
            return onRowClick(evt, i);
          },
          onDoubleClick: function onDoubleClick(evt) {
            return onRowDoubleClick(evt, i);
          },
          key: "horizontal-line-".concat(groupId),
          isEvenRow: i % 2 === 0,
          group: groups[i],
          horizontalLineClassNamesForGroup: horizontalLineClassNamesForGroup,
          style: {
            width: canvasWidth,
            height: groupHeight,
            background: 'lightgray',
            border: '1px solid blue',
            position: 'relative'
          },
          keys: keys
        }, _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_Columns["default"], {
          canvasTimeStart: canvasTimeStart,
          canvasTimeEnd: canvasTimeEnd,
          canvasWidth: canvasWidth,
          lineCount: (0, _generic._length)(groups),
          minUnit: minUnit,
          timeSteps: timeSteps,
          height: groupHeight,
          verticalLineClassNamesForTime: verticalLineClassNamesForTime
        }), _react["default"].createElement(_Items["default"] //TODO: fix groups with no items
        , {
          items: group.items || [],
          canvasTimeStart: canvasTimeStart,
          canvasTimeEnd: canvasTimeEnd,
          canvasWidth: canvasWidth,
          dragSnap: dragSnap,
          minResizeWidth: minResizeWidth,
          selectedItem: selectedItem,
          canChangeGroup: canChangeGroup,
          canMove: canMove,
          canResize: canResize,
          canSelect: canSelect,
          keys: keys,
          moveResizeValidator: moveResizeValidator,
          itemSelect: itemSelect,
          itemDrag: itemDrag,
          itemDrop: itemDrop,
          itemResizing: itemResizing,
          itemResized: _this2.handleResizeEnd,
          onItemDoubleClick: onItemDoubleClick,
          onItemContextMenu: onItemContextMenu,
          itemRenderer: itemRenderer,
          selected: selected,
          groupDimensions: group,
          useResizeHandle: useResizeHandle,
          scrollRef: scrollRef,
          order: group,
          onDragStart: _this2.handleDragStart,
          onDragEnd: _this2.handleDragEnd,
          onResizeStart: _this2.handleResizeStart,
          resizeEdge: resizeEdge,
          resizeTime: resizeTime,
          dragging: _this2.state.dragging,
          resizing: _this2.state.resizing,
          dragOffset: _this2.state.dragOffset,
          interactingItemId: _this2.state.interactingItemId
        }), _react["default"].createElement(Layers, {
          getLayerRootProps: _this2.getLayerRootProps,
          helpers: {
            getLeftOffsetFromDate: getLeftOffsetFromDate,
            getDateFromLeftOffsetPosition: _this2.getDateFromLeftOffsetPosition,
            getItemAbsoluteLocation: _this2.getItemAbsoluteLocation,
            getItemDimensions: _this2.getItemDimensionsHelper
          },
          rowData: rowData,
          group: group.group,
          itemsWithInteractions: items
        })));
      }));
    }
  }]);

  return Rows;
}(_react["default"].Component);

_defineProperty(Rows, "contextType", _TimelineStateContext["default"]);

var _default = Rows;
exports["default"] = _default;